/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable unicorn/prefer-module */
/* eslint-disable unicorn/consistent-destructuring */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import { Loader } from "..";
import { DATOS_IPSOS } from "../../constants/datosIpsos";
import { esInstalando, generaComision } from "../../constants/estadosEdificio";
import { useAuthContext } from "../../context/auth";
import adigitalLogo from "../../img/adigital-logo.png";
import screenmediaLogo from "../../img/screenmedia-logo.png";
import visionaLogo from "../../img/visiona-logo.png";
import wecastLogo from "../../img/wecast-logo.png";
import { getEdificios, useCurrency, calculateImpactosEfectivos } from "../../utils";
import { getClientesPorAgencia } from "../../utils/cotizacionesGuardadas";
import { Header } from "../Header";
import PdfCotizacion from "../PdfCotizacion";
import { CalculadoraTable } from "./components/CalculadoraTable";
import { ModalDescuento } from "./components/ModalDescuento";
import { ModalVincular } from "./components/ModalVincular";
import { MESES } from "./constants";
import { useCalculadoraCalcs } from "./hooks/useCalculadoraCalcs";
import { useClientesData } from "./hooks/useClientesData";
import { useDiscountState } from "./hooks/useDiscountState";
import { useEdificiosData } from "./hooks/useEdificiosData";
import { useEditModeState } from "./hooks/useEditModeState";
import { useOportunidadHandlers } from "./hooks/useOportunidadHandlers";
import { useSaveCotizacionHandler } from "./hooks/useSaveCotizacionHandler";
import { PDFDownloadLink } from "@react-pdf/renderer";
import styles from "./CotizadorProgrammaticCalculadora.module.scss";

export const CotizadorProgrammaticCalculadora = ({
  inventarioData,
  plazo,
  frecuencia,
  horasSeleccionadas = { horas: 0, intervalos: [], options: [] },
  duracion = 0, // Default value for duracion
  isProgrammaticSelected,
  onIncludeInstallingBuildingsChange,
  cotizacionCode,
  includeInstallingBuildings: includeInstallingBuildingsProp = false,
  isEditMode = false,
  cliente = "",
  opportunityId,
  opportunityData,
  cotizacionGuardada,
}) => {
  const [showLinkModal, setShowLinkModal] = useState(false);
  const [clienteParaDescarga, setClienteParaDescarga] = useState(null);
  const sanitizeFileName = (str) => (str ? str.replace(/["*/:<>?\\|]/g, "_") : "");
  const [tipoCotizacion, setTipoCotizacion] = useState("");
  const [forceDollars, setForceDollars] = useState(false);

  const { session, nombre, apellido, pais, rol, id: userId, agencia } = useAuthContext();

  // const OMNICOM_AGENCY_IDS = [110, 79, 85, 28];
  // const isOmnicom = agencia && OMNICOM_AGENCY_IDS.includes(agencia);

  const { usdToLocal, loadingRates, exchangeDate, formatAmount } = useCurrency();

  // --- Hook: carga de clientes ---
  const { clientes, clientesLoading, renderClientesOptions } = useClientesData({ pais, rol, userId, agencia });

  // --- Hook: estado del descuento manual ---
  const {
    showDiscountModal,
    setShowDiscountModal,
    manualDiscountAmount,
    setManualDiscountAmount,
    finalAmount,
    setFinalAmount,
    setOriginalAmount,
    discountPercentage,
    setDiscountPercentage,
    discountType,
    setDiscountType,
    discountMethod,
    setDiscountMethod,
    forceRecalc,
    setForceRecalc,
    finalAmountStr,
    setFinalAmountStr,
    manualDiscountAmountStr,
    setManualDiscountAmountStr,
    discountPercentageStr,
    setDiscountPercentageStr,
    manualDiscountPercentage,
    validateDiscount,
  } = useDiscountState({ isEditMode, opportunityData, rol, userId });

  // --- Hook: edificios (inventario total, seleccionados, audiencia, nombres) ---
  const {
    edificios,
    ascensoresTotal,
    totemsTotal,
    coworkTotal,
    esperaTotal,
    edificiosSeleccionadosAscensores,
    edificiosSeleccionadosTotems,
    edificiosSeleccionadosCowork,
    edificiosSeleccionadosEspera,
    edificiosUnicosTotal,
    ascensoresSeleccionados,
    totemsSeleccionados,
    coworkSeleccionados,
    esperaSeleccionados,
    audienciaSeleccionadaAscensor,
    audienciaSeleccionadaTotems,
    audienciaSeleccionadaCowork,
    audienciaSeleccionadaEspera,
    audienciaSeleccionadaTotal,
    nombresEdificiosSeleccionadosAscensores,
    nombresEdificiosSeleccionadosTotems,
    nombresEdificiosSeleccionadosCowork,
    nombresEdificiosSeleccionadosEspera,
    nombresEdificiosNoSeleccionados,
    hasInstallingBuildings,
    includeInstallingBuildings,
    setIncludeInstallingBuildings,
    setAscensoresSeleccionados,
    setTotemsSeleccionados,
    setCoworkSeleccionados,
    setEsperaSeleccionados,
    setAudienciaSeleccionadaAscensor,
    setAudienciaSeleccionadaTotems,
    setAudienciaSeleccionadaCowork,
    setAudienciaSeleccionadaEspera,
    setAudienciaSeleccionadaTotal,
    setEdificiosSeleccionadosAscensores,
    setEdificiosSeleccionadosTotems,
    setEdificiosSeleccionadosCowork,
    setEdificiosSeleccionadosEspera,
    setEdificiosUnicosTotal,
  } = useEdificiosData({ pais, inventarioData, includeInstallingBuildingsProp, isEditMode });

  const navigate = useNavigate();

  const linkFormMethods = useForm({
    defaultValues: {
      clientePublicitario: "",
      tipoCotizacion: "",
      campana: "",
      canal: "",
      mes_cierre: "",
      ano_cierre: new Date().getFullYear().toString(),
      mes_factura: "",
      ano_factura: new Date().getFullYear().toString(),
      estatus: "",
      // Contratos multi-mes
      is_multi_month: false,
      distribucion_tipo: "prorrateo",
      plazo_modo: "mes_tipo",
      multi_month_start_month: "",
      multi_month_start_year: new Date().getFullYear().toString(),
      multi_month_end_month: "",
      multi_month_end_year: new Date().getFullYear().toString(),
      // Meses de pauta (cuándo se emite la campaña)
      pauta_start_month: "",
      pauta_start_year: new Date().getFullYear().toString(),
      pauta_end_month: "",
      pauta_end_year: new Date().getFullYear().toString(),
      // Audiencia de referencia
      audiencia_referencia: false,
      audiencia_contratada: "",
    },
  });

  const {
    register: registerLink,
    handleSubmit: handleSubmitLink,
    formState: { errors: linkErrors },
    setValue: setLinkValue,
    watch: watchLink,
  } = linkFormMethods;

  const currentMonth = new Date().getMonth() + 1; // getMonth() devuelve 0-11, sumamos 1 para 1-12
  const orderedMeses = [
    ...MESES.slice(currentMonth - 1), // Meses desde el actual hasta diciembre
    ...MESES.slice(0, currentMonth - 1), // Meses desde enero hasta el mes anterior al actual
  ];

  const logos = {
    Chile: wecastLogo,
    Perú: visionaLogo,
    Uruguay: screenmediaLogo,
    Region: adigitalLogo,
  };

  const logo = useMemo(() => logos[pais] || visionaLogo, [pais]);

  // Datos IPSOS para el país actual
  const datosIpsos = useMemo(() => DATOS_IPSOS[pais] || DATOS_IPSOS.Chile, [pais]);

  // Cálculo de Impactos Efectivos con modelo Poisson/IPSOS (duración trayecto estándar: 45 segundos)
  const impactosEfectivosPoisson = useMemo(() => {
    const DURACION_TRAYECTO_ESTANDAR = 45; // segundos
    const frecuenciaNumero = parseInt(frecuencia, 10) || 0;
    const horasFinal = horasSeleccionadas?.horas || 0;

    if (!plazo || !frecuenciaNumero || !duracion || !horasFinal) {
      return { ascensores: 0, totems: 0, cowork: 0, espera: 0, total: 0 };
    }

    const paramsComunes = {
      duracionSpot: duracion,
      frecuenciaPorHora: frecuenciaNumero,
      diasCampana: plazo,
      duracionTrayecto: DURACION_TRAYECTO_ESTANDAR,
      horasExhibicion: horasFinal,
      datosIpsos,
    };

    const impactosAscensores = calculateImpactosEfectivos({
      ...paramsComunes,
      audienciaTotal: inventarioData?.audienciaSeleccionadaAscensor || 0,
    });

    const impactosTotems = calculateImpactosEfectivos({
      ...paramsComunes,
      audienciaTotal: inventarioData?.audienciaSeleccionadaTotems || 0,
    });

    const impactosCowork = calculateImpactosEfectivos({
      ...paramsComunes,
      audienciaTotal: inventarioData?.audienciaSeleccionadaCowork || 0,
    });

    const impactosEspera = calculateImpactosEfectivos({
      ...paramsComunes,
      audienciaTotal: inventarioData?.audienciaSeleccionadaEspera || 0,
    });

    return {
      ascensores: Math.round(impactosAscensores.impactosTotalesCampana),
      totems: Math.round(impactosTotems.impactosTotalesCampana),
      cowork: Math.round(impactosCowork.impactosTotalesCampana),
      espera: Math.round(impactosEspera.impactosTotalesCampana),
      total: Math.round(
        impactosAscensores.impactosTotalesCampana +
          impactosTotems.impactosTotalesCampana +
          impactosCowork.impactosTotalesCampana +
          impactosEspera.impactosTotalesCampana
      ),
    };
  }, [plazo, frecuencia, duracion, horasSeleccionadas, inventarioData, datosIpsos]);

  const formatExchangeDate = (dateStr) => {
    if (!dateStr) return "actualizando...";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const operacionTextual = useCallback(
    (pais) =>
      ({
        Chile: "WECAST",
        Perú: "VISIONA",
        Uruguay: "SCREENMEDIA",
      })[pais] || "VISIONA",
    []
  );

  const validateData = useCallback(() => {
    if (plazo <= 0) {
      toast.error("El plazo debe ser mayor a 0");
      return false;
    }
    if (!["5", "10", "15", "20", "25", "30"].includes(frecuencia)) {
      toast.error("Selecciona una frecuencia válida (5, 10, 15, 20, 25 o 30)");
      return false;
    }
    // Check if at least one building is selected across any circuit
    if (
      (inventarioData.edificiosSeleccionadosAscensores?.length || 0) === 0 &&
      (inventarioData.edificiosSeleccionadosTotems?.length || 0) === 0 &&
      (inventarioData.edificiosSeleccionadosEspera?.length || 0) === 0 &&
      (inventarioData.edificiosSeleccionadosCowork?.length || 0) === 0
    ) {
      toast.error("Debes seleccionar al menos un edificio");
      return false;
    }
    if (horasSeleccionadas.horas <= 0) {
      toast.error("Las horas deben ser mayores a 0");
      return false;
    }
    if (duracion <= 0) {
      toast.error("La duración debe ser mayor a 0");
      return false;
    }
    if (!includeInstallingBuildings) {
      const selectedBuildingIds = [
        ...(inventarioData.edificiosSeleccionadosAscensores || []),
        ...(inventarioData.edificiosSeleccionadosTotems || []),
        ...(inventarioData.edificiosSeleccionadosCowork || []),
        ...(inventarioData.edificiosSeleccionadosEspera || []),
      ];
      const invalidBuildings = selectedBuildingIds.some((id) => {
        const edificio = edificios.find((e) => e.id === id);
        return edificio && esInstalando(edificio.estado);
      });
      if (invalidBuildings) {
        toast.error("No puedes incluir edificios en instalación o reactivación si la opción está desactivada.");
        return false;
      }
    }
    return true;
  }, [
    plazo,
    frecuencia,
    inventarioData.edificiosSeleccionadosAscensores,
    inventarioData.edificiosSeleccionadosTotems,
    inventarioData.edificiosSeleccionadosEspera,
    inventarioData.edificiosSeleccionadosCowork,
    horasSeleccionadas.horas,
    duracion,
    includeInstallingBuildings,
    edificios, // Nueva dependencia
  ]);

  const obtenerTipoDeCambio = useCallback(() => {
    if (!usdToLocal) return 1; // Fallback si no hay tasa
    return usdToLocal;
  }, [usdToLocal]);

  const getMonedaSymbol = useCallback((monedaCode) => {
    const symbols = {
      USD: "US$",
      CLP: "$",
      PEN: "S/",
      UF: "UF",
    };
    return symbols[monedaCode] || "$";
  }, []);

  const obtenerFechaActual = () => {
    const fecha = new Date();
    const year = fecha.getFullYear();
    const month = (fecha.getMonth() + 1).toString().padStart(2, "0");
    const day = fecha.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const generarCodigoAleatorio = () => {
    const letras = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    let codigo = "";
    for (let i = 0; i < 6; i++) {
      codigo += letras.charAt(Math.floor(Math.random() * letras.length));
    }
    return codigo;
  };

  // Nota: validateDiscount y carga descuento desde opportunityData están ahora en useDiscountState
  // Nota: calculateProposalChanges está ahora en useEditModeState

  // Nota: carga de clientes y renderClientesOptions están ahora en useClientesData

  // Motor de cálculo principal (reemplaza el useEffect gigante)
  const {
    horasFinal,
    salidasAscensores,
    salidasTotems,
    salidasCowork,
    salidasEspera,
    salidasTotales,
    contactosCampañaAscensores,
    contactosCampañaTotems,
    contactosCampañaCowork,
    contactosCampañaEspera,
    contactosCampañaTotal,
    impactosTotalAscensores,
    impactosTotalTotems,
    impactosTotalCowork,
    impactosTotalEspera,
    impactosTotales,
    inversionAscensoresFinal,
    inversionTotemsFinal,
    inversionCoworkFinal,
    inversionEsperaFinal,
    inversionFinalTotal,
    tarifaFriaAscensores,
    tarifaFriaTotems,
    tarifaFriaCowork,
    tarifaFriaEspera,
    tarifaFriaTotal,
    cpmAscensoresFinal,
    cpmTotemsFinal,
    cpmCoworkFinal,
    cpmEsperaFinal,
    cpmTotalFinal,
    descuentoGlobal,
    selectedMoneda,
    baseInversionFinalTotal,
    effectiveManualDiscountAmount,
    effectiveFinalAmount,
    effectiveDiscountPercentage,
  } = useCalculadoraCalcs({
    ascensoresSeleccionados,
    totemsSeleccionados,
    coworkSeleccionados,
    esperaSeleccionados,
    audienciaSeleccionadaAscensor,
    audienciaSeleccionadaTotems,
    audienciaSeleccionadaCowork,
    audienciaSeleccionadaEspera,
    ascensoresTotal,
    totemsTotal,
    coworkTotal,
    esperaTotal,
    plazo,
    frecuencia,
    horasSeleccionadas,
    duracion,
    pais,
    forceDollars,
    obtenerTipoDeCambio,
    getMonedaSymbol,
    discountType,
    discountPercentage,
    manualDiscountAmount,
    finalAmount,
    forceRecalc,
  });

  // Sincronizar valores efectivos del descuento con los estados (mantiene comportamiento original)
  useEffect(() => {
    setManualDiscountAmount(effectiveManualDiscountAmount);
    setFinalAmount(effectiveFinalAmount);
    if (discountType !== "none") {
      setOriginalAmount(baseInversionFinalTotal);
    }
    setDiscountPercentage(effectiveDiscountPercentage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [effectiveManualDiscountAmount, effectiveFinalAmount, effectiveDiscountPercentage, baseInversionFinalTotal]);

  // Nota: el useEffect de sync inventarioData está ahora en useEdificiosData

  // --- Hook: estado modo edición (formulario, cambios, inicialización) ---
  const {
    editMesCierre,
    setEditMesCierre,
    editAnoCierre,
    setEditAnoCierre,
    editMesFactura,
    setEditMesFactura,
    editAnoFactura,
    setEditAnoFactura,
    editEstatus,
    setEditEstatus,
    setInitialData,
    isInitialized,
    setIsInitialized,
    hasChanges,
    hasProposalChanges,
    calculateProposalChanges,
    initialLoadComplete,
    originalDiscountWasReset,
    setOriginalDiscountWasReset,
  } = useEditModeState({
    isEditMode,
    opportunityData,
    inventarioData,
    plazo,
    frecuencia,
    horasSeleccionadas,
    duracion,
    isProgrammaticSelected,
    inversionFinalTotal,
  });

  const [codigoGenerado] = useState(() => {
    if (isEditMode) return opportunityData?.code;
    if (cotizacionGuardada?.codigo_generado) return cotizacionGuardada.codigo_generado;
    return generarCodigoAleatorio();
  });
  const currentOpportunityId = parseInt(opportunityId, 10);

  // --- Hook: handlers de oportunidad (guardar, actualizar, clonar) ---
  const {
    loading,
    isSubmitting,
    cloningLoading,
    handleLinkOportunidad,
    handleUpdateOportunidad,
    handleCloneOportunidad,
  } = useOportunidadHandlers({
    clientes,
    userId,
    rol,
    isProgrammaticSelected,
    inventarioData,
    inversionFinalTotal,
    edificiosUnicosTotal,
    ascensoresSeleccionados,
    totemsSeleccionados,
    coworkSeleccionados,
    esperaSeleccionados,
    frecuencia,
    plazo,
    duracion,
    pais,
    horasSeleccionadas,
    codigoGenerado,
    opportunityData,
    manualDiscountAmount,
    finalAmount,
    forceDollars,
    editMesCierre,
    editAnoCierre,
    editMesFactura,
    editAnoFactura,
    editEstatus,
    validateData,
    calculateProposalChanges,
    navigate,
    setShowLinkModal,
    setClienteParaDescarga,
    currentOpportunityId,
    audienciaSeleccionadaTotal,
    salidasTotales,
    impactosTotales,
    tarifaFriaTotal,
    cpmTotalFinal,
    descuentoGlobal,
  });

  // --- Hook: guardar cotización para CLIENTE/AGENCIA ---
  const { isSaving, showGuardarModal, setShowGuardarModal, handleGuardarCotizacion, handleGuardarSilencioso } =
    useSaveCotizacionHandler({
      userId,
      pais,
      nombre,
      apellido,
      clienteId: null,
      clienteNombre: null,
      inventarioData,
      isProgrammaticSelected,
      frecuencia,
      plazo,
      duracion,
      horasSeleccionadas,
      codigoGenerado,
      forceDollars,
      discountType,
      discountPercentage,
      manualDiscountAmount,
      finalAmount,
      ascensoresSeleccionados,
      totemsSeleccionados,
      coworkSeleccionados,
      esperaSeleccionados,
      edificiosUnicosTotal,
      audienciaSeleccionadaTotal,
      audienciaSeleccionadaAscensor,
      audienciaSeleccionadaTotems,
      audienciaSeleccionadaCowork,
      audienciaSeleccionadaEspera,
      salidasAscensores,
      salidasTotems,
      salidasCowork,
      salidasEspera,
      salidasTotales,
      impactosTotalAscensores,
      impactosTotalTotems,
      impactosTotalCowork,
      impactosTotalEspera,
      impactosTotales,
      inversionAscensoresFinal,
      inversionTotemsFinal,
      inversionCoworkFinal,
      inversionEsperaFinal,
      inversionFinalTotal,
      tarifaFriaAscensores,
      tarifaFriaTotems,
      tarifaFriaCowork,
      tarifaFriaEspera,
      tarifaFriaTotal,
      cpmAscensoresFinal,
      cpmTotemsFinal,
      cpmCoworkFinal,
      cpmEsperaFinal,
      cpmTotalFinal,
      descuentoGlobal,
      horasFinal,
      contactosCampañaAscensores,
      contactosCampañaTotems,
      contactosCampañaCowork,
      contactosCampañaEspera,
      impactosEfectivosPoisson,
      nombresEdificiosSeleccionadosAscensores,
      nombresEdificiosSeleccionadosTotems,
      nombresEdificiosSeleccionadosCowork,
      nombresEdificiosSeleccionadosEspera,
      cotizacionGuardadaId: cotizacionGuardada?.id || null,
      navigate,
    });

  // State para modal guardar cotización
  const [guardarNombre, setGuardarNombre] = useState(cotizacionGuardada?.nombre_cotizacion || "");
  const [guardarClienteId, setGuardarClienteId] = useState(
    cotizacionGuardada?.cliente_id ? String(cotizacionGuardada.cliente_id) : ""
  );
  const [clientesAgencia, setClientesAgencia] = useState([]);
  const [clientesAgenciaLoading, setClientesAgenciaLoading] = useState(false);

  // Cargar clientes de la agencia al abrir modal guardar
  useEffect(() => {
    if (rol !== "agencia" || !agencia || !pais || !showGuardarModal) return;
    const fetchClientes = async () => {
      setClientesAgenciaLoading(true);
      try {
        const data = await getClientesPorAgencia(pais, agencia);
        setClientesAgencia(data);
      } catch {
        setClientesAgencia([]);
      } finally {
        setClientesAgenciaLoading(false);
      }
    };
    fetchClientes();
  }, [rol, agencia, pais, showGuardarModal]);

  useEffect(() => {
    if (isEditMode && opportunityData) {
      const ascensoresIds = opportunityData.pantallas_ascensores
        ? opportunityData.pantallas_ascensores.split(",").filter(Boolean).map(Number)
        : [];
      const totemsIds = opportunityData.pantallas_circulacion
        ? opportunityData.pantallas_circulacion.split(",").filter(Boolean).map(Number)
        : [];
      const esperaIds = opportunityData.pantallas_espera
        ? opportunityData.pantallas_espera.split(",").filter(Boolean).map(Number)
        : [];
      const coworkIds = opportunityData.pantallas_cowork
        ? opportunityData.pantallas_cowork.split(",").filter(Boolean).map(Number)
        : [];

      let ascensoresSeleccionados = 0;
      let totemsSeleccionados = 0;
      let esperaSeleccionados = 0;
      let coworkSeleccionados = 0;
      let audienciaSeleccionadaAscensor = 0;
      let audienciaSeleccionadaTotems = 0;
      let audienciaSeleccionadaEspera = 0;
      let audienciaSeleccionadaCowork = 0;

      const fetchEdificios = async () => {
        try {
          let edificiosData = (await getEdificios({ pais })).filter((edificio) => !edificio.eliminada);

          // Aplicar filtro basado en includeInstallingBuildings
          edificiosData = includeInstallingBuildings
            ? edificiosData
            : edificiosData.filter((edificio) => generaComision(edificio.estado));

          edificiosData.forEach((edificio) => {
            if (ascensoresIds.includes(edificio.id)) {
              ascensoresSeleccionados += edificio.pantallas || 0;
              audienciaSeleccionadaAscensor += edificio.personas || 0;
            }
            if (totemsIds.includes(edificio.id)) {
              totemsSeleccionados += edificio.totems || 0;
              audienciaSeleccionadaTotems += edificio.personas || 0;
            }
            if (esperaIds.includes(edificio.id)) {
              esperaSeleccionados += edificio.espera || 0;
              audienciaSeleccionadaEspera += edificio.personas || 0;
            }
            if (coworkIds.includes(edificio.id)) {
              coworkSeleccionados += edificio.cowork || 0;
              audienciaSeleccionadaCowork += edificio.personas || 0;
            }
          });

          const audienciaSeleccionadaTotal =
            audienciaSeleccionadaAscensor +
            audienciaSeleccionadaTotems +
            audienciaSeleccionadaEspera +
            audienciaSeleccionadaCowork;

          setAscensoresSeleccionados(ascensoresSeleccionados);
          setTotemsSeleccionados(totemsSeleccionados);
          setEsperaSeleccionados(esperaSeleccionados);
          setCoworkSeleccionados(coworkSeleccionados);
          setAudienciaSeleccionadaAscensor(audienciaSeleccionadaAscensor);
          setAudienciaSeleccionadaTotems(audienciaSeleccionadaTotems);
          setAudienciaSeleccionadaEspera(audienciaSeleccionadaEspera);
          setAudienciaSeleccionadaCowork(audienciaSeleccionadaCowork);
          setAudienciaSeleccionadaTotal(audienciaSeleccionadaTotal);
          setEdificiosSeleccionadosAscensores(ascensoresIds.length);
          setEdificiosSeleccionadosTotems(totemsIds.length);
          setEdificiosSeleccionadosEspera(esperaIds.length);
          setEdificiosSeleccionadosCowork(coworkIds.length);

          const totalEdificiosUnicos = new Set([...ascensoresIds, ...totemsIds, ...esperaIds, ...coworkIds]).size;
          setEdificiosUnicosTotal(totalEdificiosUnicos);

          // Nueva línea para cargar forceDollars desde opportunityData
          setForceDollars(opportunityData.moneda_dolar || false);

          // Nueva lógica para cargar estados de descuento manual y tipo
          const hasManualDiscount = opportunityData.has_manual_discount === true;
          const savedDiscountAmount = parseFloat(opportunityData.manual_discount_amount) || 0;
          const savedOriginalAmount = parseFloat(opportunityData.original_amount) || 0;
          const savedPercentage = savedOriginalAmount > 0 ? (savedDiscountAmount / savedOriginalAmount) * 100 : 0;
          const savedFinalAmount = parseFloat(opportunityData.importe) || 0;

          setOriginalAmount(savedOriginalAmount);
          setDiscountPercentage(savedPercentage);
          if (hasManualDiscount) {
            setManualDiscountAmount(savedDiscountAmount);
            setFinalAmount(savedFinalAmount);
            setFinalAmountStr(savedFinalAmount.toString());
            setManualDiscountAmountStr(savedDiscountAmount.toString());
            setDiscountPercentageStr(savedPercentage.toString());
            setDiscountType("amount"); // Asumimos 'amount' por default en carga; ajusta si sabes el tipo original
          } else {
            setDiscountType("none");
          }

          const initial = {
            edificiosparticipantes: opportunityData.edificiosparticipantes || "",
            pantallas_ascensores: opportunityData.pantallas_ascensores || "",
            pantallas_circulacion: opportunityData.pantallas_circulacion || "",
            pantallas_espera: opportunityData.pantallas_espera || "",
            pantallas_cowork: opportunityData.pantallas_cowork || "",
            periodopauta: opportunityData.periodopauta || 0,
            formatopauta: opportunityData.formatopauta ? String(opportunityData.formatopauta) : "15",
            horas_pauta: opportunityData.horas_pauta || 14,
            intervalos: opportunityData.intervalos ? JSON.parse(opportunityData.intervalos) : [],
            options: opportunityData.options
              ? JSON.parse(opportunityData.options)
              : [{ label: "FULL DAY | 07:00 - 21:00", hours: 14 }],
            duracion: opportunityData.duracion || 10,
            tipo: opportunityData.tipo || "d",
            mes_cierre: opportunityData.mes_cierre
              ? String(parseInt(opportunityData.mes_cierre.split("-")[0], 10))
              : "",
            ano_cierre: opportunityData.mes_cierre
              ? opportunityData.mes_cierre.split("-")[1]
              : opportunityData.ano || new Date().getFullYear().toString(),
            mes_factura: opportunityData.mes_factura
              ? String(parseInt(opportunityData.mes_factura.split("-")[0], 10))
              : "",
            ano_factura: opportunityData.mes_factura
              ? opportunityData.mes_factura.split("-")[1]
              : opportunityData.ano || new Date().getFullYear().toString(),
            estatus: opportunityData.estatus || "0%",
            importe: opportunityData.importe || 0,
          };
          setInitialData(initial);
          setIsInitialized(true);
          setForceRecalc((prev) => prev + 1); // Nueva: Forzar recálculo después de carga inicial
        } catch (error) {
          console.error("Error al cargar edificios para inicialización:", error);
          toast.error("Error al inicializar los datos de la oportunidad.");
        }
      };

      fetchEdificios();
    }
  }, [isEditMode, opportunityData, pais, includeInstallingBuildings]);

  // eslint-disable-next-line no-unused-vars
  const { intervalos, horas, options } = horasSeleccionadas;

  // Resetear descuento manual cuando hay cambios en la propuesta comercial
  useEffect(() => {
    // Solo actuar si: modo edición, inicializado, carga inicial completa, y hay cambios en propuesta
    if (!isEditMode || !isInitialized || !initialLoadComplete || !hasProposalChanges) return;

    // Solo resetear si había un descuento manual original
    const hadOriginalDiscount = opportunityData?.has_manual_discount === true;
    if (hadOriginalDiscount && !originalDiscountWasReset) {
      setManualDiscountAmount(0);
      setDiscountType("none");
      setDiscountPercentage(0);
      setManualDiscountAmountStr("0");
      setDiscountPercentageStr("0");
      setOriginalDiscountWasReset(true);
      toast(
        "El descuento manual fue eliminado debido a cambios en la propuesta. Por favor re-defina si es necesario.",
        { icon: "⚠️", duration: 5000 }
      );
    }
  }, [hasProposalChanges, isEditMode, isInitialized, initialLoadComplete, opportunityData, originalDiscountWasReset]);

  // Nota: el useEffect de totales/nombres de edificios está ahora en useEdificiosData

  // Nota: el useEffect de sync strings de descuento está ahora en useDiscountState

  const todosLosTotalesCompletos = () =>
    edificiosUnicosTotal > 0 &&
    ascensoresSeleccionados + totemsSeleccionados + coworkSeleccionados + esperaSeleccionados > 0 &&
    audienciaSeleccionadaTotal > 0 &&
    horasFinal > 0 &&
    plazo > 0 &&
    salidasTotales > 0 &&
    impactosTotales > 0 &&
    duracion > 0 &&
    tarifaFriaTotal > 0 &&
    inversionFinalTotal > 0 &&
    cpmTotalFinal;

  const usuarioNombre = nombre || "usuario";
  const usuarioApellido = apellido || "usuario";

  // El PDF debe heredar EXACTAMENTE el total que muestra la celda TOTAL de pantalla
  // (inversionTotalDisplay en CalculadoraTable). Misma precedencia: ventas cerradas sin
  // cambios congelan sales.importe; con descuento manual prevalece finalAmount; en otro caso
  // el recálculo vivo. Ver ARQUITECTURA 4.17.2.
  const monedaGuardada = opportunityData?.moneda_dolar || false;
  let inversionTotalReal;
  if (manualDiscountAmount > 0) {
    inversionTotalReal = finalAmount;
  } else if (!hasProposalChanges && forceDollars === monedaGuardada && opportunityData?.importe) {
    inversionTotalReal = opportunityData.importe;
  } else {
    inversionTotalReal = inversionFinalTotal;
  }

  const generatePdfDocument = () => (
    <PdfCotizacion
      nombresEdificiosSeleccionadosAscensores={nombresEdificiosSeleccionadosAscensores}
      nombresEdificiosSeleccionadosTotems={nombresEdificiosSeleccionadosTotems}
      nombresEdificiosSeleccionadosCowork={nombresEdificiosSeleccionadosCowork}
      nombresEdificiosSeleccionadosEspera={nombresEdificiosSeleccionadosEspera}
      nombresEdificiosNoSeleccionados={nombresEdificiosNoSeleccionados}
      edificiosUnicosTotal={edificiosUnicosTotal}
      ascensoresSeleccionados={ascensoresSeleccionados}
      totemsSeleccionados={totemsSeleccionados}
      coworkSeleccionados={coworkSeleccionados}
      esperaSeleccionados={esperaSeleccionados}
      audienciaSeleccionadaTotal={audienciaSeleccionadaTotal}
      audienciaSeleccionadaAscensor={audienciaSeleccionadaAscensor}
      audienciaSeleccionadaTotems={audienciaSeleccionadaTotems}
      audienciaSeleccionadaCowork={audienciaSeleccionadaCowork}
      audienciaSeleccionadaEspera={audienciaSeleccionadaEspera}
      horasFinal={horasFinal}
      plazo={plazo}
      salidasTotales={salidasTotales}
      salidasAscensores={salidasAscensores}
      salidasTotems={salidasTotems}
      salidasCowork={salidasCowork}
      salidasEspera={salidasEspera}
      impactosTotales={impactosTotales}
      impactosTotalAscensores={impactosTotalAscensores}
      impactosTotalTotems={impactosTotalTotems}
      impactosTotalCowork={impactosTotalCowork}
      impactosTotalEspera={impactosTotalEspera}
      contactosCampañaAscensores={contactosCampañaAscensores}
      contactosCampañaTotems={contactosCampañaTotems}
      contactosCampañaCowork={contactosCampañaCowork}
      contactosCampañaEspera={contactosCampañaEspera}
      impactosEfectivosPoisson={impactosEfectivosPoisson}
      duracion={duracion}
      tarifaFriaTotal={tarifaFriaTotal}
      tarifaFriaAscensores={tarifaFriaAscensores}
      tarifaFriaTotems={tarifaFriaTotems}
      tarifaFriaCowork={tarifaFriaCowork}
      tarifaFriaEspera={tarifaFriaEspera}
      descuentoGlobal={descuentoGlobal}
      inversionFinalTotal={inversionFinalTotal}
      inversionTotalReal={inversionTotalReal}
      inversionAscensoresFinal={inversionAscensoresFinal}
      inversionTotemsFinal={inversionTotemsFinal}
      inversionCoworkFinal={inversionCoworkFinal}
      inversionEsperaFinal={inversionEsperaFinal}
      cpmTotalFinal={cpmTotalFinal}
      cpmAscensoresFinal={cpmAscensoresFinal}
      cpmTotemsFinal={cpmTotemsFinal}
      cpmCoworkFinal={cpmCoworkFinal}
      cpmEsperaFinal={cpmEsperaFinal}
      selectedMoneda={selectedMoneda}
      logo={logo}
      pais={pais}
      cliente={clienteParaDescarga || cliente}
      campana={opportunityData?.campana || ""}
      fecha={obtenerFechaActual()}
      usuario={`${usuarioNombre} ${usuarioApellido}`}
      operacion={operacionTextual(pais)}
      isProgrammaticSelected={isProgrammaticSelected}
      intervalos={horasSeleccionadas?.intervalos || []}
      options={horasSeleccionadas?.options || []}
      usuarioNombre={usuarioNombre}
      usuarioApellido={usuarioApellido}
      frecuencia={frecuencia}
      codigoGenerado={codigoGenerado}
      includeInstallingBuildings={includeInstallingBuildings}
      manualDiscountAmount={manualDiscountAmount}
      finalAmount={finalAmount}
      manualDiscountPercentage={manualDiscountPercentage}
      edificios={edificios}
    />
  );

  const pdfDocument = useMemo(
    () => generatePdfDocument(),
    [
      nombresEdificiosSeleccionadosAscensores,
      nombresEdificiosSeleccionadosTotems,
      nombresEdificiosSeleccionadosCowork,
      nombresEdificiosSeleccionadosEspera,
      nombresEdificiosNoSeleccionados,
      edificiosUnicosTotal,
      ascensoresSeleccionados,
      totemsSeleccionados,
      coworkSeleccionados,
      esperaSeleccionados,
      audienciaSeleccionadaTotal,
      audienciaSeleccionadaAscensor,
      audienciaSeleccionadaTotems,
      audienciaSeleccionadaCowork,
      audienciaSeleccionadaEspera,
      horasFinal,
      plazo,
      salidasTotales,
      salidasAscensores,
      salidasTotems,
      salidasCowork,
      salidasEspera,
      impactosTotales,
      impactosTotalAscensores,
      impactosTotalTotems,
      impactosTotalCowork,
      impactosTotalEspera,
      impactosEfectivosPoisson,
      duracion,
      tarifaFriaTotal,
      tarifaFriaAscensores,
      tarifaFriaTotems,
      tarifaFriaCowork,
      tarifaFriaEspera,
      descuentoGlobal,
      inversionFinalTotal,
      inversionTotalReal,
      inversionAscensoresFinal,
      inversionTotemsFinal,
      inversionCoworkFinal,
      inversionEsperaFinal,
      cpmTotalFinal,
      cpmAscensoresFinal,
      cpmTotemsFinal,
      cpmCoworkFinal,
      cpmEsperaFinal,
      selectedMoneda,
      logo,
      pais,
      clienteParaDescarga,
      cliente,
      opportunityData?.campana,
      usuarioNombre,
      usuarioApellido,
      operacionTextual,
      isProgrammaticSelected,
      horasSeleccionadas?.intervalos,
      horasSeleccionadas?.options,
      frecuencia,
      codigoGenerado,
      includeInstallingBuildings,
    ]
  );

  const canLinkOpportunity = ["comercial", "gerencia", "superadmin", "broker"].includes(rol);

  if (session === undefined)
    return (
      <>
        <Header />
        <Loader fullPage />
      </>
    );

  const handleCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setIncludeInstallingBuildings(isChecked);
    if (onIncludeInstallingBuildingsChange) {
      onIncludeInstallingBuildingsChange(isChecked);
    }
  };

  // Nueva función generateFileName
  const generateFileName = (client = null, campana = null, isForLink = false) => {
    const fecha = obtenerFechaActual();
    const operacion = operacionTextual(pais);
    const codigo = cotizacionCode || codigoGenerado;

    let baseFileName;
    if (isEditMode) {
      // En modo edición, incluir cliente y campaña de opportunityData
      const version = opportunityData?.version ? parseInt(opportunityData.version, 10) + 1 : 1;
      baseFileName = `${fecha}. ${operacion} - Cotización ${codigo} - ${sanitizeFileName(cliente || "Sin Cliente")} - ${sanitizeFileName(opportunityData?.campana || "Sin Campaña")} - versión ${version}.pdf`;
    } else if (isForLink && client && campana) {
      // Para "Vincular cliente", incluir cliente y campaña
      baseFileName = `${fecha}. ${operacion} - Cotización ${codigo} - ${sanitizeFileName(client)} - ${sanitizeFileName(campana)}.pdf`;
    } else {
      // Para "Generar PDF" o cualquier otro caso, usar formato simple
      baseFileName = `${fecha}. ${operacion} - Cotización ${codigo}.pdf`;
    }

    return baseFileName;
  };

  return (
    <>
      <Header
        leftContent={
          <>
            {isEditMode && (
              <h2 className={styles.clienteTitle}>
                <strong>{cliente}</strong> | #{cotizacionCode}
              </h2>
            )}
            <div className={styles.checkboxColumn}>
              {pais !== "Region" && (
                <div className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id="forceDollars"
                    checked={forceDollars}
                    onChange={(e) => setForceDollars(e.target.checked)}
                    disabled={loadingRates}
                  />
                  <label htmlFor="forceDollars" className={styles.checkboxLabel}>
                    {forceDollars ? "COTIZANDO EN USD" : "COTIZAR EN USD"}
                  </label>
                  {!loadingRates && usdToLocal > 0 && forceDollars && (
                    <div className={styles.exchangeRateInline}>
                      <span className={styles.exchangeLabel}>USD → {pais === "Chile" ? "CLP" : "PEN"}:</span>
                      <span className={styles.exchangeValue}>
                        {usdToLocal.toLocaleString(pais === "Chile" ? "es-CL" : "es-PE", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </span>
                      <span className={styles.exchangeDate}>({formatExchangeDate(exchangeDate)})</span>
                    </div>
                  )}
                </div>
              )}
              {hasInstallingBuildings && (
                <div className={styles.checkboxContainer}>
                  <input
                    type="checkbox"
                    id="includeInstallingBuildings"
                    checked={includeInstallingBuildings}
                    onChange={handleCheckboxChange}
                  />
                  <label htmlFor="includeInstallingBuildings" className={styles.checkboxLabel}>
                    INCLUIR EDIFICIOS EN INSTALACIÓN
                  </label>
                </div>
              )}
            </div>
          </>
        }
      >
        <div className={styles.headerButtons}>
          {["superadmin", "gerencia", "comercial"].includes(rol) && (
            <Button
              className="action-button"
              color="dark"
              onClick={() => setShowDiscountModal(true)}
              disabled={!todosLosTotalesCompletos()}
              style={{ width: "110px", height: "40px" }}
            >
              Descuento
            </Button>
          )}
          {!isEditMode && ["gerencia", "comercial", "broker"].includes(rol) && (
            <Button
              className="action-button"
              color="dark"
              onClick={() => setShowLinkModal(true)}
              disabled={!todosLosTotalesCompletos()}
              style={{ width: "110px", height: "40px" }}
            >
              Vincular
            </Button>
          )}
          {!isEditMode && ["cliente", "agencia"].includes(rol) && (
            <Button
              className="action-button"
              color="primary"
              onClick={() => {
                if (cotizacionGuardada) {
                  handleGuardarCotizacion(
                    cotizacionGuardada.nombre_cotizacion || "",
                    cotizacionGuardada.cliente_id || null,
                    cotizacionGuardada.cliente_nombre || null
                  );
                } else {
                  setShowGuardarModal(true);
                }
              }}
              disabled={!todosLosTotalesCompletos() || isSaving}
              style={{ width: "auto", minWidth: "110px", height: "40px", padding: "0 12px" }}
            >
              {isSaving ? "..." : cotizacionGuardada ? "Nueva versión" : "Guardar"}
            </Button>
          )}
          {todosLosTotalesCompletos() ? (
            <PDFDownloadLink
              document={pdfDocument}
              fileName={generateFileName()}
              onClick={() => {
                if (!cotizacionGuardada?.id) {
                  handleGuardarSilencioso(null, null, null);
                } else {
                  handleGuardarSilencioso(
                    cotizacionGuardada?.nombre_cotizacion,
                    cotizacionGuardada?.cliente_id,
                    cotizacionGuardada?.cliente_nombre
                  );
                }
              }}
            >
              {({ loading: pdfLoading }) => (
                <Button
                  className="action-button"
                  color="dark"
                  disabled={pdfLoading}
                  style={{ width: "110px", height: "40px" }}
                >
                  {pdfLoading ? "..." : "PDF"}
                </Button>
              )}
            </PDFDownloadLink>
          ) : (
            <Button className="action-button" color="dark" disabled style={{ width: "110px", height: "40px" }}>
              PDF
            </Button>
          )}
          {isEditMode && (
            <Button
              className="action-button"
              color="dark"
              onClick={() => handleUpdateOportunidad({ generatePdfDocument, generateFileName })}
              disabled={!hasChanges || loading}
              style={{ width: "110px", height: "40px" }}
            >
              {loading ? "..." : "Editar"}
            </Button>
          )}
          {/* OBSOLETO/INACTIVO: el botón "Clonar" se deshabilitó (false &&) por decisión de negocio.
              cloneOportunidad bypasea saveOportunidad → las ventas clonadas nacen SIN snapshot de
              comisión. Las versiones de una venta se hacen en el cotizador (v1/v2/v3), no clonando.
              Código de handleCloneOportunidad/cloneOportunidad se conserva, solo sin acceso desde la UI. */}
          {false && isEditMode && (
            <Button
              className="action-button"
              color="dark"
              onClick={handleCloneOportunidad}
              disabled={cloningLoading}
              style={{ width: "110px", height: "40px" }}
            >
              {cloningLoading ? "..." : "Clonar"}
            </Button>
          )}
        </div>
      </Header>
      <div className={styles.tableContainerA}>
        {isEditMode && (
          <div className={styles.editFormContainer}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleUpdateOportunidad({ generatePdfDocument, generateFileName });
              }}
              className="mt-2"
            >
              <div
                className="d-flex align-items-center justify-content-center mb-2"
                style={{ maxWidth: "500px", margin: "0 auto" }}
              >
                <div className="d-flex align-items-center">
                  <label htmlFor="mes_cierre" style={{ width: "150px", fontSize: "1rem" }}>
                    Mes de cierre:
                  </label>
                  <select
                    className="form-select"
                    style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                    value={editMesCierre}
                    onChange={(e) => setEditMesCierre(e.target.value)}
                  >
                    <option value="">Selecciona...</option>
                    {MESES.map((mes) => (
                      <option key={mes.value} value={mes.value}>
                        {mes.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="ms-4 me-4" style={{ fontSize: "1.5rem" }}>
                  |
                </div>
                <div className="d-flex align-items-center">
                  <label htmlFor="ano_cierre" style={{ width: "150px", fontSize: "1rem" }}>
                    Año de cierre:
                  </label>
                  <select
                    className="form-select"
                    style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                    value={editAnoCierre}
                    onChange={(e) => setEditAnoCierre(e.target.value)}
                  >
                    <option value="">Selecciona...</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                  </select>
                </div>
                <div className="ms-4 me-4" style={{ fontSize: "1.5rem" }}>
                  |
                </div>
                <div className="d-flex align-items-center">
                  <label htmlFor="mes_factura" style={{ width: "150px", fontSize: "1rem" }}>
                    Mes de factura:
                  </label>
                  <select
                    className="form-select"
                    style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                    value={editMesFactura}
                    onChange={(e) => setEditMesFactura(e.target.value)}
                  >
                    <option value="">Selecciona...</option>
                    {MESES.map((mes) => (
                      <option key={mes.value} value={mes.value}>
                        {mes.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="ms-4 me-4" style={{ fontSize: "1.5rem" }}>
                  |
                </div>
                <div className="d-flex align-items-center">
                  <label htmlFor="ano_factura" style={{ width: "150px", fontSize: "1rem" }}>
                    Año de factura:
                  </label>
                  <select
                    className="form-select"
                    style={{ width: "120px", fontSize: "1rem", padding: "0.25rem" }}
                    value={editAnoFactura}
                    onChange={(e) => setEditAnoFactura(e.target.value)}
                  >
                    <option value="">Selecciona...</option>
                    <option value="2025">2025</option>
                    <option value="2026">2026</option>
                    <option value="2027">2027</option>
                  </select>
                </div>
                <div className="ms-4 mb-0" style={{ fontSize: "1.5rem" }}>
                  |
                </div>
                <div className="d-flex align-items-center">
                  <label htmlFor="estatus" style={{ width: "200px", fontSize: "1rem" }}>
                    Status:
                  </label>
                  <select
                    className="form-select"
                    style={{ width: "90px", fontSize: "0.9rem", padding: "0.25rem" }}
                    value={editEstatus}
                    onChange={(e) => setEditEstatus(e.target.value)}
                  >
                    <option value="0%">0%</option>
                    <option value="50%">50%</option>
                    <option value="75%">75%</option>
                    <option value="90%">90%</option>
                    <option value="100%">100%</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        )}
        <CalculadoraTable
          ascensoresSeleccionados={ascensoresSeleccionados}
          edificiosSeleccionadosAscensores={edificiosSeleccionadosAscensores}
          audienciaSeleccionadaAscensor={audienciaSeleccionadaAscensor}
          salidasAscensores={salidasAscensores}
          contactosCampañaAscensores={contactosCampañaAscensores}
          impactosTotalAscensores={impactosTotalAscensores}
          tarifaFriaAscensores={tarifaFriaAscensores}
          inversionAscensoresFinal={inversionAscensoresFinal}
          totemsTotal={totemsTotal}
          totemsSeleccionados={totemsSeleccionados}
          edificiosSeleccionadosTotems={edificiosSeleccionadosTotems}
          audienciaSeleccionadaTotems={audienciaSeleccionadaTotems}
          salidasTotems={salidasTotems}
          contactosCampañaTotems={contactosCampañaTotems}
          impactosTotalTotems={impactosTotalTotems}
          tarifaFriaTotems={tarifaFriaTotems}
          inversionTotemsFinal={inversionTotemsFinal}
          esperaTotal={esperaTotal}
          esperaSeleccionados={esperaSeleccionados}
          edificiosSeleccionadosEspera={edificiosSeleccionadosEspera}
          audienciaSeleccionadaEspera={audienciaSeleccionadaEspera}
          salidasEspera={salidasEspera}
          contactosCampañaEspera={contactosCampañaEspera}
          impactosTotalEspera={impactosTotalEspera}
          tarifaFriaEspera={tarifaFriaEspera}
          inversionEsperaFinal={inversionEsperaFinal}
          coworkTotal={coworkTotal}
          coworkSeleccionados={coworkSeleccionados}
          edificiosSeleccionadosCowork={edificiosSeleccionadosCowork}
          audienciaSeleccionadaCowork={audienciaSeleccionadaCowork}
          salidasCowork={salidasCowork}
          contactosCampañaCowork={contactosCampañaCowork}
          impactosTotalCowork={impactosTotalCowork}
          tarifaFriaCowork={tarifaFriaCowork}
          inversionCoworkFinal={inversionCoworkFinal}
          edificiosUnicosTotal={edificiosUnicosTotal}
          audienciaSeleccionadaTotal={audienciaSeleccionadaTotal}
          salidasTotales={salidasTotales}
          contactosCampañaTotal={contactosCampañaTotal}
          impactosTotales={impactosTotales}
          tarifaFriaTotal={tarifaFriaTotal}
          inversionFinalTotal={inversionFinalTotal}
          impactosEfectivosPoisson={impactosEfectivosPoisson}
          plazo={plazo}
          duracion={duracion}
          descuentoGlobal={descuentoGlobal}
          manualDiscountPercentage={manualDiscountPercentage}
          manualDiscountAmount={manualDiscountAmount}
          finalAmount={finalAmount}
          pais={pais}
          selectedMoneda={selectedMoneda}
          opportunityData={opportunityData}
          hasProposalChanges={hasProposalChanges}
          forceDollars={forceDollars}
          todosLosTotalesCompletos={todosLosTotalesCompletos}
          styles={styles}
        />
      </div>
      <ModalVincular
        showLinkModal={showLinkModal}
        setShowLinkModal={setShowLinkModal}
        clientesLoading={clientesLoading}
        handleSubmitLink={handleSubmitLink}
        registerLink={registerLink}
        linkErrors={linkErrors}
        setLinkValue={setLinkValue}
        handleLinkOportunidad={handleLinkOportunidad}
        generatePdfDocument={generatePdfDocument}
        generateFileName={generateFileName}
        tipoCotizacion={tipoCotizacion}
        setTipoCotizacion={setTipoCotizacion}
        renderClientesOptions={renderClientesOptions}
        orderedMeses={orderedMeses}
        isSubmitting={isSubmitting}
        canLinkOpportunity={canLinkOpportunity}
        watchLink={watchLink}
        inversionFinalTotal={inversionFinalTotal}
        finalAmount={finalAmount}
        manualDiscountAmount={manualDiscountAmount}
        audienciaSeleccionadaTotal={audienciaSeleccionadaTotal}
        pais={pais}
        plazo={plazo}
        clientes={clientes}
        forceDollars={forceDollars}
      />
      <ModalDescuento
        showDiscountModal={showDiscountModal}
        setShowDiscountModal={setShowDiscountModal}
        discountMethod={discountMethod}
        setDiscountMethod={setDiscountMethod}
        finalAmountStr={finalAmountStr}
        setFinalAmountStr={setFinalAmountStr}
        manualDiscountAmountStr={manualDiscountAmountStr}
        setManualDiscountAmountStr={setManualDiscountAmountStr}
        discountPercentageStr={discountPercentageStr}
        setDiscountPercentageStr={setDiscountPercentageStr}
        finalAmount={finalAmount}
        setFinalAmount={setFinalAmount}
        manualDiscountAmount={manualDiscountAmount}
        setManualDiscountAmount={setManualDiscountAmount}
        discountPercentage={discountPercentage}
        setDiscountPercentage={setDiscountPercentage}
        setDiscountType={setDiscountType}
        setOriginalAmount={setOriginalAmount}
        setForceRecalc={setForceRecalc}
        selectedMoneda={selectedMoneda}
        inversionFinalTotal={baseInversionFinalTotal}
        impactosTotales={impactosTotales}
        formatAmount={formatAmount}
        validateDiscount={validateDiscount}
        isEditMode={isEditMode}
        rol={rol}
        userId={userId}
        customModalClassName={styles.customModal}
      />

      {/* ─── MODAL GUARDAR COTIZACIÓN ─── */}
      {showGuardarModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1050,
          }}
          onClick={() => setShowGuardarModal(false)}
        >
          <div
            style={{
              background: "white",
              borderRadius: 8,
              width: "90%",
              maxWidth: 550,
              boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "16px 20px",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h5 style={{ margin: 0, fontWeight: 600 }}>Guardar cotización</h5>
              <button className="btn-close" onClick={() => setShowGuardarModal(false)} />
            </div>
            <div style={{ padding: 20 }}>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: "0.85rem", fontWeight: 500, marginBottom: 4, display: "block" }}>
                  Nombre de la cotización <span style={{ color: "#c62828" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Ej: Campaña Verano 2026"
                  required
                  value={guardarNombre}
                  onChange={(e) => setGuardarNombre(e.target.value)}
                />
              </div>
              {rol === "agencia" && (
                <div style={{ marginBottom: 12 }}>
                  <label style={{ fontSize: "0.85rem", fontWeight: 500, marginBottom: 4, display: "block" }}>
                    Cliente
                  </label>
                  {clientesAgenciaLoading ? (
                    <p style={{ fontSize: "0.85rem", color: "#666" }}>Cargando clientes...</p>
                  ) : clientesAgencia.length === 0 ? (
                    <div
                      style={{
                        padding: "8px 12px",
                        background: "#fff3cd",
                        border: "1px solid #ffc107",
                        borderRadius: 6,
                        fontSize: "0.85rem",
                        color: "#856404",
                      }}
                    >
                      No tiene clientes asociados, contactar a su ejecutivo comercial.
                    </div>
                  ) : (
                    <select
                      className="form-select"
                      value={guardarClienteId}
                      onChange={(e) => setGuardarClienteId(e.target.value)}
                    >
                      <option value="">-- Sin asignar --</option>
                      {clientesAgencia.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.nombre}
                          {c.producto ? ` - ${c.producto}` : ""}
                        </option>
                      ))}
                    </select>
                  )}
                </div>
              )}
              <div style={{ fontSize: "0.8rem", color: "#666" }}>
                Código: <strong>{codigoGenerado}</strong>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
                padding: "16px 20px",
                borderTop: "1px solid #e0e0e0",
              }}
            >
              <button className="btn btn-sm btn-secondary" onClick={() => setShowGuardarModal(false)}>
                Cancelar
              </button>
              <button
                className="btn btn-sm btn-primary"
                disabled={isSaving || !guardarNombre.trim()}
                onClick={() => {
                  const cliente = clientesAgencia.find((c) => String(c.id) === String(guardarClienteId));
                  handleGuardarCotizacion(guardarNombre, cliente?.id || null, cliente?.nombre || null);
                }}
              >
                {isSaving ? "Guardando..." : "Guardar"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
